import classNames from 'classnames';

import { ProductConfigurationOrigin } from '../../data/model';
import css from './ConfigurationImage.css';
import DefaultImage from './DefaultImage/DefaultImage';
import { LoadableImage, LoadableImageProps } from './LoadableImage';

interface ConfigurationImageProps extends LoadableImageProps {
  configurationCodeOrigin: ProductConfigurationOrigin;
  imageFallbackClassName?: string;
}

const ConfigurationImage = ({
  configurationCodeOrigin,
  imageFallbackClassName,
  className,
  ...props
}: ConfigurationImageProps) => {
  return (
    <>
      {configurationCodeOrigin === ProductConfigurationOrigin.DefaultConfigurator && (
        <LoadableImage className={className} {...props} />
      )}
      {configurationCodeOrigin === ProductConfigurationOrigin.RawConfigurator && (
        <div className={className}>
          <DefaultImage className={classNames(css.imageFallback, imageFallbackClassName)} />
        </div>
      )}
    </>
  );
};

export default ConfigurationImage;
